import { createContext } from "react";

export const UserGroupsContext = createContext<string[]>([]);
export const SetUserGroupsContext = createContext<
  React.Dispatch<React.SetStateAction<string[]>>
>(() => {});
